module.exports = __webpack_public_path__ + "static/media/19_l_lamp_27.19_0.b8a25a64.png";